<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <WorkPackageLarge :color="getWP1.color" class="comparison-wp">
          <template #head>
            <WorkPackageLargeHead
              :work_packages="[getWP1]"
              :selected_id="getWP1.id">
              <template #name><small>{{getWP1.name}}</small></template>
            </WorkPackageLargeHead>
          </template>
          <template #body>
            <v-row class="pl-5">
              <v-col cols="6">
                <b>{{$t('AiDashboard.Description')}}:</b><br>
                <StandardTextfield :color="`${getWP1.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP1.description" />
                <b>{{$t('AiDashboard.Manpower')}}:</b><br>
                <StandardTextfield :color="`${getWP1.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP1.manpower" />
              </v-col>
              <v-col cols="6">
                <b>{{$t('AiDashboard.QuantityValue')}}:</b><br>
                <StandardTextfield :color="`${getWP1.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP1.quantity_value" />
                <b>{{$t('AiDashboard.QuantityUnit')}}:</b><br>
                <StandardTextfield :color="`${getWP1.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP1.quantity_unit" />
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col cols="1"></v-col>
              <v-col cols="10">
                <StandardTextfield
                  v-for="tws_1 in getWP1.work_steps"
                  :key="tws_1.id"
                  :color="`${getWP1.color} lighten-2`"
                  icon="radio_button_unchecked"
                  type="text"
                  class="mb-2"
                  style="width: 100%"
                  :readonly="true"
                  :value="tws_1.text" />
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </template>
        </WorkPackageLarge>
      </v-col>
      <v-col cols="6">
        <WorkPackageLarge :color="getWP2.color" class="comparison-wp">
          <template #head>
            <WorkPackageLargeHead
              :work_packages="[getWP2]"
              :selected_id="getWP2.id">
              <template #name><small>{{getWP2.name}}</small></template>
            </WorkPackageLargeHead>
          </template>
          <template #body>
            <v-row class="pl-5">
              <v-col cols="6">
                <b>Description:</b><br>
                <StandardTextfield :color="`${getWP2.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP2.description" />
                <b>Manpower:</b><br>
                <StandardTextfield :color="`${getWP2.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP2.manpower" />
              </v-col>
              <v-col cols="6">
                <b>Quantity value:</b><br>
                <StandardTextfield :color="`${getWP2.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP2.quantity_value" />
                <b>Quantity unit:</b><br>
                <StandardTextfield :color="`${getWP2.color} lighten-2`"
                  type="text" style="width: 100%" :readonly="true"
                  :value="getWP2.quantity_unit" />
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col cols="1"></v-col>
              <v-col cols="10">
                <StandardTextfield
                  v-for="tws_2 in getWP2.work_steps"
                  :key="tws_2.id"
                  :color="`${getWP2.color} lighten-2`"
                  icon="radio_button_unchecked"
                  type="text"
                  class="mb-2"
                  style="width: 100%"
                  :readonly="true"
                  :value="tws_2.text" />
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </template>
        </WorkPackageLarge>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="pa-2 pull-right">
          <v-btn large color="green" @click="createSimilarityLabel(true)">{{$t('AiDashboard.Similarity.Similar')}}</v-btn>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="pa-2">
          <v-btn large color="red" @click="createSimilarityLabel(false)">{{$t('AiDashboard.Similarity.NotSimilar')}}</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="1">
        <v-btn large color="grey" @click="getTwoRandomWPs()">{{$t('AiDashboard.Discard')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import WorkPackageLarge from '@/components/WorkPackages/WorkPackageLarge.component.vue';
import WorkPackageLargeHead from '@/components/WorkPackages/WorkPackageLargeHead.component.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'WPSimilarity',
  components: {
    StandardTextfield,
    WorkPackageLarge,
    WorkPackageLargeHead
  },
  created(){
    this.getTwoRandomWPs();
  },
  computed: {
    ...mapGetters('AI', [
      'getWP1',
      'getWP2'
    ])
  },
  methods: {
    ...mapActions('AI', [
      'getTwoRandomWPs',
      'createSimilarityLabel'
    ])
  }
}
</script>

<style lang="css" scoped>
.comparison-wp {
  height: 600px;
  overflow-y: auto;
}
</style>
